<template>
  <div class="prozess-wrapper">
    <div class="prozess">
      <div>
        <div v-if="!claimed">
          <TaskBlocker :assignee="data.assignee" />
        </div>

        <div v-if="!isLoading">
          <v-alert
            text
            type="warning"
            border="left"
            colored-border
          >
            Achtung: Die Dienstauftragsbestätigung muss manuell über Start
            Support versendet werden
          </v-alert>
          <v-tabs v-model="selectedTab" background-color="rgba(0,0,0,0.05)">
            <v-tab v-if="showHausanschlussauftragTab">
              <v-icon left>
                mdi-home-outline
              </v-icon>
              Hausanschlussauftrag
            </v-tab>
            <v-tab v-if="showDienstauftragTab">
              <v-icon left>
                mdi-web
              </v-icon>
              Dienstauftrag
            </v-tab>
          </v-tabs>
          <DisplayContainer label="Auftragsdaten" style="margin-top: 15px">
            <v-container>
              <v-row>
                <v-col>
                  <DataDisplay label="Vertragsnummer">
                    {{ contractId || '-' }}
                  </DataDisplay>
                </v-col>
                <v-col>
                  <DataDisplay label="Kundennummer">
                    {{ customerId || '-' }}
                  </DataDisplay>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <DataDisplay label="Firma ">
                    {{ company || '-' }}
                  </DataDisplay>
                </v-col>
                <v-col>
                  <DataDisplay label="Adresse ">
                    {{ address || '-' }}
                  </DataDisplay>
                </v-col>
              </v-row>
            </v-container>
            <div class="buttons-wrapper">
              <v-btn
                :disabled="!claimed"
                large
                color="primary"
                @click="completeTask"
              >
                Fertig
              </v-btn>
            </div>
          </DisplayContainer>
        </div>
        <div v-else>
          <Loader />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayContainer from '@/components/elements/DisplayContainer.vue';
import DataDisplay from '@/components/elements/DataDisplay.vue';
import NotificationObject from '@/main/NotificationObject.js';
import TaskBlocker from '../TaskBlocker.vue';
import Loader from '@/components/Loader.vue';
import { HTTP } from '../../main/httpClient';

export default {
  name: 'ActionManualGKContractProcessing',
  components: {
    DisplayContainer,
    DataDisplay,
    Loader,
    TaskBlocker
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    contractIds: [],
    contractMap: new Map(),
    customerIds: [],
    houseConnectionContractId: undefined,
    serviceContractId: undefined,
    orderType: null,
    selectedTab: null
  }),
  computed: {
    username() {
      return this.$store.getters.getUsername;
    },
    claimed() {
      return this.data.assignee === this.username;
    },
    showHausanschlussauftragTab() {
      return (
        this.orderType === 'HOUSECONNECTION' ||
        this.orderType === 'HOUSECONNECTION_WITH_SERVICE'
      );
    },
    showDienstauftragTab() {
      return (
        this.orderType === 'SERVICE' ||
        this.orderType === 'HOUSECONNECTION_WITH_SERVICE'
      );
    },
    company() {
      if (!this.selectedContract) return '';
      return this.selectedContract.company;
    },
    address() {
      if (!this.selectedContract) return '';
      const { street, houseNumber, houseNumberSupplement, zipCode, city } =
        this.selectedContract;
      return `${street ?? ''} ${houseNumber ?? ''}${
        houseNumberSupplement ?? ''
      }, ${zipCode ?? ''} ${city ?? ''}`;
    },
    selectedContract() {
      return this.contractMap.get(this.contractId);
    },
    contractId() {
      return this.contractIds[this.selectedTab];
    },
    customerId() {
      return this.customerIds[this.selectedTab];
    }
  },
  mounted: async function () {
    this.isLoading = true;
    // fix race condition after reopen the same task
    await new Promise((resolve) => {
      setTimeout(resolve, 1);
    });

    this.data.variables.then(this.handleVariables);
  },
  methods: {
    handleVariables: function (taskVariables) {
      const variables = Object.keys(taskVariables).reduce((obj, key) => {
        obj[key] = taskVariables[key].value;
        return obj;
      }, {});

      this.contractIds = [
        variables.houseConnectionContractId,
        variables.serviceContractId
      ].filter((c) => c);

      this.customerIds = [
        variables.houseConnectionCustomerId,
        variables.serviceCustomerId
      ].filter((c) => c);

      this.fetchCustomerInfo();

      if (variables.order && variables.order.orderType) {
        this.orderType = variables.order.orderType;
      }

      this.selectedTab = 0;
    },
    fetchCustomerInfo() {
      const promises = this.contractIds.map((contractId) => {
        return HTTP.get(`/customer/addressByType/${contractId}/INVOICE`).then(
          ({ data }) => {
            this.contractMap.set(contractId, data);
          }
        );
      });

      Promise.all(promises)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.showMessage('error', 'Fehler beim laden der Taskdaten');
        });
    },
    completeTask() {
      this.isLoading = true;
      HTTP.post(
        `/orderTask/manualGKContractProcessing/completeTask/${this.data.id}`
      )
        .then(() => {
          this.showMessage(
            'success',
            'Die Aufgabe wurde erfolgreich abgeschlossen.'
          );
          this.$store.commit('triggerTasksRefresh');
          this.$emit('onClose');
        })
        .catch((e) => {
          this.showMessage(
            'error',
            'Die Aufgabe konnte nicht erfolgreich abgeschlossen werden.'
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showMessage: function (type, description) {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, description)
      );
    }
  }
};
</script>

<style scoped>
.buttons-wrapper .v-btn {
  width: max-content;
  margin-left: auto;
  margin-right: var(--goe-spacing-1);
  float: right;
}
</style>
